import { useSelector } from 'react-redux'
import { trialSlice, subscriptionSlice } from '../reducers'
import { useMemo } from 'react'
import usePaidConsumer from './usePaidConsumer'

const useIsOnTrial = () => {
  const { isPaidConsumer } = usePaidConsumer()
  const accountInfo = useSelector(subscriptionSlice.selectors.selectAccountInfo)
  const isUserOnTrial = useMemo(() => accountInfo.trial === true, [accountInfo])
  const isTrialBannerDismissed = useSelector(trialSlice.selectors.selectTrialBannerDismissed)

  // Only return true if user is both a paid consumer AND on trial
  const isOnTrial = useMemo(() => {
    return isPaidConsumer && isUserOnTrial
  }, [isPaidConsumer, isUserOnTrial])

  // For styling purposes, banner should only affect layout if it's visible
  // (i.e., user is on trial AND hasn't dismissed the banner)
  const isTrialBannerVisible = useMemo(() => {
    return isOnTrial && !isTrialBannerDismissed
  }, [isOnTrial, isTrialBannerDismissed])

  return {
    isOnTrial,
    isTrialBannerVisible
  }
}

export default useIsOnTrial
